export default __webpack_public_path__ + "static/media/english-to-french-logo.0a444bd9.png";